import * as ROUTES from '../backend-routes'
import { executePost } from '../requests/axios'

export const revokeSession = function (uid, payload, onSuccess, onError) {
  executePost(ROUTES.LOGOUT.PATH_REVOKE_SESSION + uid, payload, onSuccess, onError)
}
